import { useQuery } from "@tanstack/react-query";

import type { CloudSettings } from "../models/settings";

import { BaseController } from "./baseController";
import { QUERY_KEYS } from "./queryKeys";

const Get = BaseController.GetFn("Settings");

export function useCloudSettingsQuery() {
	const { data: settings, isFetching: settingsLoading } = useQuery({
		queryKey: [QUERY_KEYS.Settings],
		queryFn: () => Get<CloudSettings>(""),
	});

	return { settings, settingsLoading };
}
